import React, { useEffect, useState } from 'react'
import { CustomButton, FilterBar, TableData } from '../../components';
import DownloadIcon from "@mui/icons-material/Download";
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import { useDispatch, useSelector } from 'react-redux';
import { setConciliacionesDiferenciasReport, setConciliacionesReport } from '../../redux/slices/report/reportSlice';
import { getProvidersService, getConciliacionesDiferenciasReportService, getConciliacionesReportService, downloadConciliacionesReportService } from '../../services/report/reportService';
import { errorAlert } from '../../helpers/alerts';
import moment from 'moment';
import { setTitle } from '../../redux/slices/uiSlice';
import { currencyFormatter, downloadFile } from '../../helpers/util';
import ColumnFilterModal from "../../components/modal/ColumnFilterModal";
import { Downloading, DownloadingOutlined, Filter1Outlined, PendingOutlined } from '@mui/icons-material';
import Image from 'components/common/Image';
import Images from 'assets/images';
import { useLocation } from 'react-router-dom';

const columns_diferencias = [
  { name: "provider", label: "Proveedor", format: ({ provider }) => provider },
  { name: "cred", label: "Instancia", format: ({ cred }) => cred },
  { name: "saldo_gastado", label: "Saldo Gastado", format: ({ saldo_gastado }) => currencyFormatter.format(saldo_gastado) },
  { name: "saldo_conciliado", label: "Saldo Conciliado", format: ({ saldo_conciliado }) => currencyFormatter.format(saldo_conciliado) },
]


const columns = [
  { name: "type", label: "Movimiento", format: ({ typeReg }) => typeReg },
  { name: "operator", label: "Operadora", format: ({ providerCarrier }) => providerCarrier },
  { name: "phone", label: "Telefono", format: ({ phoneNumber }) => phoneNumber },
  { name: "import", label: "Importe", format: ({ typeReg, Amount, operacionSaldo }) => currencyFormatter.format(typeReg === 'TAE' ? Amount : operacionSaldo) },
  { name: "prevBalance", label: "Saldo Anterior", format: ({ saldoAnterior }) => saldoAnterior ? currencyFormatter.format(saldoAnterior) : '' },
  { name: "currentBalance", label: "Saldo Actual", format: ({ saldoActual }) => saldoActual ? currencyFormatter.format(saldoActual) : '' },
  { name: "operacionSaldo", label: "Debitado", format: ({ operacionSaldo }) => currencyFormatter.format(operacionSaldo) },
  { name: "discount_porcent", label: "% Descuento", format: ({ discount_porcent }) => discount_porcent ? `${discount_porcent}%` : '' },
  { name: "discount_applied", label: "Descuento", format: ({ discount_applied }) => discount_applied ? currencyFormatter.format(discount_applied) : '' },
  { name: "reference", label: "Referencia", format: ({ typeReg, ProviderReference, referenceSaldo }) => typeReg === 'TAE' ? ProviderReference : referenceSaldo },
  { name: "state", label: "Estado", format: ({ typeReg, ProviderResponseMessage }) => typeReg === 'TAE' ? ProviderResponseMessage : '' },
  { name: "datetime", label: "Fecha y hora", format: ({ createdAt }) => moment(createdAt).format('DD/MM/YYYY HH:mm:ss') },
  { name: "auth", label: "Autorización", format: ({ AuthCode }) => AuthCode },
  { name: "code", label: "Codigo", format: ({ ProviderResponseCode }) => ProviderResponseCode },
  { name: "region", label: "Región", format: ({ region }) => region },
  { name: "bag", label: "Bolsa", format: ({ hosterBagId }) => hosterBagId.hashtag },
  { name: "provider", label: "Proveedor", format: ({ serviceName }) => serviceName },
  { name: "conciliacion", label: "Conciliación", format: ({ conciliacion }) => conciliacion ? 'SI' : 'NO' },
  { name: "conciliacion_date", label: "Fecha de conciliación", format: ({ conciliacion_date }) => conciliacion_date > 0 ? moment(conciliacion_date).format('DD/MM/YYYY HH:mm:ss') : '--' },
]


const ConciliacionDetailScreen = () => {
  const dispatch = useDispatch();
  const { conciliacionesDiferenciasReport, conciliacionesReport } = useSelector(store => store.reports);
  const [loading, setLoading] = useState(false)
  const [downloadFilters, setDownloadFilters] = useState({})
  const [providers, setProviders] = useState([])
  const [showColumnFilterModal, setShowColumnFilterModal] = useState(false)

  const [selectedColums, setSetSelectedColums] = useState([
    "type",
    "operator",
    "phone",
    "import",
    "state",
    "datetime",
    "auth",
    "code",
    "provider",
    "cred",
    "conciliacion",
    "conciliacion_date"
  ])

  useEffect(() => {
    setLoading(true)
    getProvidersService({})
      .then((response) => setProviders(response || []))
      .catch((e) => errorAlert(e))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  const handlerSubmitCD = async (data) => {
    setLoading(true)
    setDownloadFilters(data)
    getConciliacionesDiferenciasReportService(data)
      .then((response) => dispatch(setConciliacionesDiferenciasReport(response || [])))
      .catch((e) => errorAlert(e))
      .finally(() => setLoading(false));
  }

  const handlerSubmitC = async (data) => {
    setLoading(true)
    setDownloadFilters(data)
    getConciliacionesReportService(data)
      .then((response) => dispatch(setConciliacionesReport(response || [])))
      .catch((e) => errorAlert(e))
      .finally(() => setLoading(false));
  }

  const handlerDownload = async () => {
    setLoading(true)
    downloadConciliacionesReportService(downloadFilters)
      .then((data) => downloadFile(data, 'Conciliaciones.xlsx'))
      .catch((e) => errorAlert(e))
      .finally(() => setLoading(false));
  }

  const handlerSelectColumn = (columns) => {
    setSetSelectedColums(columns)
    setShowColumnFilterModal(false)
  }

  return (
    <>
      <FilterBar
        handlerFilter={(data) => {
          handlerSubmitCD(data);
          handlerSubmitC(data);
        }}
        defaultValues={{
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
        }}
        filters={[
          {
            name: "startDate",
            label: "Fecha Inicio",
            type: "date",
          },
          {
            name: "endDate",
            label: "Fecha Fin",
            type: "date",
          },
          {
            name: 'provider',
            label: "Proveedores",
            type: "select",
            all: 'Todos',
            data: providers,
          }
        ]}
      />
      <TableData
        loading={loading}
        dataRows={conciliacionesDiferenciasReport || []}
        dataTitle={columns_diferencias.map(({ label }) => label)}
        formatter={(data) => columns_diferencias.map(({ format }) => format(data))}
        actions={[
        ]}
      />
      <TableData
        loading={loading}
        dataRows={conciliacionesReport || []}
        headerButtons={[
          <CustomButton
            dark={true}
            icon={<Image src={Images.icon.columnas} />}
            key="filterColumns"
            name={"Columnas"}
            click={() => setShowColumnFilterModal(true)}
          />,
          <CustomButton
            dark={true}
            icon={Images.icon.download}
            key="dowloadBalance"
            name={"Descargar"}
            click={handlerDownload}
          />,
        ]}
        dataTitle={columns.filter(({ name }) => selectedColums.includes(name)).map(({ label }) => label)}
        formatter={(data) => columns.filter(({ name }) => selectedColums.includes(name)).map(({ format }) => format(data))}
        actions={[
        ]}
      />
      <ColumnFilterModal
        open={showColumnFilterModal}
        columns={columns}
        selected={selectedColums}
        onSuccess={handlerSelectColumn}
        onClose={() => setShowColumnFilterModal(false)}
      />
    </>

  )
}

export default ConciliacionDetailScreen